import { Component } from 'react';
import { connect } from 'react-redux';
import { MemberLogin } from "@b/listing/components/MemberLogin";
import InventoryHeaderContainer from "@v/ticket-picker/containers/InventoryHeaderContainer";
import { triggerTransition } from "@uirouter/redux";
import { bindActionCreators } from "redux";

class MemberLoginContainer extends Component {

  render() {
    return (
      <>
        <dialog className="tickets--as-overlay tickets-wrap" aria-modal="true" tabIndex="-1">
          <div className="tickets">
            <InventoryHeaderContainer />
            <MemberLogin onLogin={ this.props.$stateParams?.onLogin } isOverlay />
          </div>
        </dialog>
      </>
    )
  }
}

MemberLoginContainer.propTypes = {};

const mapStateToProps = (state) => ({
  isMembershipSkipped: !!state.ui?.skipMembership,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      triggerTransition,
    },
    dispatch
  );
}


export default connect(mapStateToProps, mapDispatchToProps)(MemberLoginContainer)
